import { render } from "./OCROChart.vue?vue&type=template&id=c3c0ed6c"
import script from "./OCROChart.vue?vue&type=script&lang=js"
export * from "./OCROChart.vue?vue&type=script&lang=js"

import "./OCROChart.vue?vue&type=style&index=0&id=c3c0ed6c&lang=css"

import exportComponent from "C:\\Users\\msimi\\Downloads\\tuaszone\\survey-agel-web-report\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__